const mediaKitList = document.querySelector('.media-list');

if (mediaKitList) {
  const urlParams = ['locations', 'types', 'audiences', 'searchTerm', 'pageNumber'];

  const getExtraFormDataInput = (parent, searchInput) => ({
    searchTerm: searchInput || getSearchedData(parent),
    postType: parent.querySelector('[data-post-type]').value,
    locations: getCheckedData(parent, 'locations'),
    types: getCheckedData(parent, 'types'),
    audiences: getCheckedData(parent, 'audiences'),
  });

  // Filter click
  attachEvent('.media-list .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.media-list');
    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.media-list .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.media-list');
    axiosGetPaginateAndFilteredPosts(parent, ev.target.dataset.page, urlParams, getExtraFormDataInput(parent));
  });

  // Search
  mediaKitList.querySelector('input[type="text"]').addEventListener('input', (ev) => {
    const parent = ev.target.closest('.media-list');
    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent, ev.target.value));
  });
}
